import _ from 'lodash';

import { Types } from 'app/actions/company-admin/page-groups-edit';
import utils from 'app/reducers/utils';

const initialState = {
  groupId: null,
  loadPending: false,
};

const reducer = utils.createReducer(initialState, {

  [`${Types.LOAD}_PENDING`]: (state, {groupId}) => {
    return {...state,
      groupId,
      loadPending: true,
    };
  },
  [`${Types.LOAD}_RESOLVED`]: (state, {groupId}) => {
    if (groupId !== state.groupId) return state;
    return {...state,
      loadPending: false,
    };
  },

});

export default reducer;
